import { COOKIE_CURRENT_ACCOUNT_SEARCH, COOKIE_MORTGAGE_SEARCH } from '@/constants/cookies';

export default async ({ $api, $cookies, route, store }) => {
  const article = store.getters['blog/getArticle'];
  if (!article.related_product) {
    return;
  }
  const klass = article.related_product.klass;
  const paths = {
    card: 'banking/cards',
    commsbundle: 'broadband/bundles',
    current: 'banking/currents',
    'energy-plan': 'energy/plans',
    mortgage: 'banking/mortgages'
  };
  const prefix = paths[klass];
  if (!prefix) {
    return;
  }
  if (klass === 'mortgage') {
    const search = $cookies.get(COOKIE_MORTGAGE_SEARCH);
    if (search && search.rate === '') {
      delete search.rate;
    }
    store.commit('search/reset', { type: 'mortgage', search });
  } else if (klass === 'current') {
    store.commit('search/reset', { type: 'current', search: $cookies.get(COOKIE_CURRENT_ACCOUNT_SEARCH) });
  }
  await $api([prefix, article.related_product.code].join('/')).then(r => {
    store.commit('products/set', { ...r, ...article.related_product });
  });
};
